interface RedirectData {
  url: string;
  timestamp: number;
  ttl: number; // Time to live in milliseconds
}

const DEFAULT_TTL = 10 * 60 * 1000; // 10 minutes
const STORAGE_PREFIX = 'redirect_';

export const redirectPreservation = {
  preserve: (key: string, url: string, ttl = DEFAULT_TTL): boolean => {
    try {
      const data: RedirectData = {
        url,
        timestamp: Date.now(),
        ttl,
      };
      sessionStorage.setItem(`${STORAGE_PREFIX}${key}`, JSON.stringify(data));
      return true;
    } catch (error) {
      console.warn('Failed to preserve redirect URL:', error);
      return false;
    }
  },

  restore: (key: string): string | null => {
    try {
      const stored = sessionStorage.getItem(`${STORAGE_PREFIX}${key}`);
      if (!stored) return null;

      const data: RedirectData = JSON.parse(stored);
      const now = Date.now();

      if (now - data.timestamp > data.ttl) {
        sessionStorage.removeItem(`${STORAGE_PREFIX}${key}`);
        return null;
      }

      sessionStorage.removeItem(`${STORAGE_PREFIX}${key}`);
      return data.url;
    } catch (error) {
      console.warn('Failed to restore redirect URL:', error);
      return null;
    }
  },

  shouldPreserve: (url: string): boolean => {
    try {
      return new URL(url).search.length > 0;
    } catch {
      return false;
    }
  },

  clearAll: (): void => {
    try {
      const keys = Object.keys(sessionStorage);
      keys.forEach(key => {
        if (key.startsWith(STORAGE_PREFIX)) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (error) {
      console.warn('Failed to clear redirect URLs:', error);
    }
  },

  hasRedirect: (key: string): boolean => {
    try {
      const stored = sessionStorage.getItem(`${STORAGE_PREFIX}${key}`);
      if (!stored) return false;

      const data: RedirectData = JSON.parse(stored);
      const now = Date.now();

      if (now - data.timestamp > data.ttl) {
        sessionStorage.removeItem(`${STORAGE_PREFIX}${key}`);
        return false;
      }

      return true;
    } catch {
      return false;
    }
  },
};
